import { IApplicationState } from '../../types/redux';
import { EUserStatus } from '../../types/userStatus';

const defaultState = {
  isAuthenticated: false,
  phones: null,
  userId: null,
  status: EUserStatus.New,
};

export function userReducer(state: IApplicationState['user'] = defaultState): IApplicationState['user'] {
  return state;
}
